import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'GENERAL';

i18next.addResources('es', NAMESPACE, {
  SEARCH: 'Buscar',
  CANCEL: 'Cancelar',
  ACCEPT: 'Aceptar',
  CONFIRM: 'Confirmar',
  DOWNLOAD: 'Descargar',
  CONFIRMATION: 'Confirmación',
  ERROR: 'Error',
  EDIT: 'Editar',
  DELETE: 'Borrar',
  ELIMINATE: 'Eliminar',
  YESTERDAY: 'Ayer',
  TOMORROW: 'Mañana',
  TODAY: 'Hoy',
  SEND: 'Enviar',
  SAVE: 'Guardar',
  SAVING: 'Guardando',
  LOADING_SEND: 'Enviando',
  CLOSE: 'Cerrar',
  BACK: 'Atrás',
  NEXT: 'Siguiente',
  FINISH: 'Finalizar',
  CREATE: 'Crear',
  LOADING_CREATE: 'Creando',
  SEE_MORE: 'ver más',
  SEE_LESS: 'ver menos',
  DROP_FILE: 'Suelte el archivo aquí',
  ERROR_DRAG_AND_DROP: 'Error al intentar subir el archivo',
  RETRY: 'Reintentar',
  RESEND: 'Reenviar',
  ERROR_GENERAL: 'Ocurrió un error',
  ERROR_GENERAL_RETRY: 'Ocurrió un error, vuelve a intentar más tarde',
  SAVE_CHANGES: 'Guardar cambios',
  MORE: 'Más',
  NEW: 'Nuevo',
  ERROR_CONNECTING_NOTIFICATIONS: 'Error al conectar las notificaciones',
  MINIMIZE: 'ocultar',
  ROWS_PER_PAGE: 'Filas por página:',
});

i18next.addResources('en', NAMESPACE, {
  SEARCH: 'Search',
  CANCEL: 'Cancel',
  ACCEPT: 'Accept',
  CONFIRM: 'Confirm',
  DOWNLOAD: 'Download',
  CONFIRMATION: 'Confirmation',
  ERROR: 'Error',
  EDIT: 'Edit',
  DELETE: 'Delete',
  ELIMINATE: 'Remove',
  YESTERDAY: 'Yesterday',
  TOMORROW: 'Tomorrow',
  TODAY: 'Today',
  SEND: 'Send',
  SAVE: 'Save',
  SAVING: 'Saving',
  LOADING_SEND: 'Sending',
  CLOSE: 'Close',
  BACK: 'Back',
  NEXT: 'Next',
  FINISH: 'Finalize',
  CREATE: 'Create',
  LOADING_CREATE: 'Creating',
  SEE_MORE: 'see more',
  SEE_LESS: 'see less',
  DROP_FILE: 'Drop the file here',
  ERROR_DRAG_AND_DROP: 'Failed to upload file',
  RETRY: 'Retry',
  RESEND: 'Resend',
  ERROR_GENERAL: 'An error ocurred',
  ERROR_GENERAL_RETRY: 'An error occurred, please try again later',
  SAVE_CHANGES: 'Save changes',
  MORE: 'More',
  NEW: 'New',
  ERROR_CONNECTING_NOTIFICATIONS: 'Failed to connect notifications',
  MINIMIZE: 'Minimize',
  ROWS_PER_PAGE: 'Rows per page:',
});

i18next.addResources('pt', NAMESPACE, {
  SEARCH: 'Pesquisar',
  CANCEL: 'Cancelar',
  ACCEPT: 'Aceitar',
  CONFIRM: 'Confirmar',
  CONFIRMATION: 'Confirmação',
  ERROR: 'Erro',
  EDIT: 'Editar',
  DELETE: 'Apagar',
  ELIMINATE: 'Remover',
  YESTERDAY: 'Ontem',
  TOMORROW: 'Manhã',
  TODAY: 'Hoje',
  SEND: 'Enviar',
  SAVE: 'Salvar',
  SAVING: 'Salvando',
  DOWNLOAD: 'Baixar',
  LOADING_SEND: 'Enviando',
  CLOSE: 'Fechar',
  BACK: 'Voltar',
  NEXT: 'Próximo',
  FINISH: 'Finalizar',
  CREATE: 'Criar',
  LOADING_CREATE: 'Criando',
  SEE_MORE: 'ver mais',
  SEE_LESS: 'ver menos',
  DROP_FILE: 'Solte o arquivo aqui',
  ERROR_DRAG_AND_DROP: 'Erro ao carregar o arquivo',
  RETRY: 'Tente novamente',
  RESEND: 'Reenviar',
  ERROR_GENERAL: 'Um erro ocorreu',
  ERROR_GENERAL_RETRY: 'Ocorreu um erro. Por favor tente novamente mais tarde',
  SAVE_CHANGES: 'Guardar mudanças',
  MORE: 'Mais',
  NEW: 'Novo',
  ERROR_CONNECTING_NOTIFICATIONS: 'Falha ao conectar as notificações',
  MINIMIZE: 'ocultar',
  ROWS_PER_PAGE: 'Linhas por página:',
});

export const useTranslation = () => usei18nextTranslation([NAMESPACE, 'GENERAL']);
